import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {
  setData(key: string, payload: unknown): void {
    const stringPayload = JSON.stringify(payload);
    localStorage.setItem(key, stringPayload);
  }

  getData<T>(key: string): T {
    const storageData = localStorage.getItem(key) as string;
    return JSON.parse(storageData);
  }
}
